import * as React from "react";
const NoNoteDataSvg = (props) => (
  <svg
    width={159}
    height={158}
    viewBox="0 0 159 158"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={1} y={0.5} width={157} height={157} rx={78.5} fill="url(#a)" />
    <rect x={1} y={0.5} width={157} height={157} rx={78.5} stroke="url(#b)" />
    <path
      d="M56.167 108.167H97a5.834 5.834 0 0 0 5.833-5.834V65.875L86.792 49.833H62a5.833 5.833 0 0 0-5.833 5.834v11.666"
      stroke="#000"
      strokeWidth={6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.333 49.833v17.5h17.5M53.25 87.75h17.5M62 79v17.5"
      stroke="#000"
      strokeWidth={6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="a"
        x1={79.5}
        y1={0}
        x2={79.5}
        y2={128.288}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1F1F1" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="b"
        x1={79.5}
        y1={0}
        x2={79.5}
        y2={158}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D4D4D4" />
        <stop offset={0.825} stopColor="#F8F4F4" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default NoNoteDataSvg;
